import { ca } from '@cian/analytics';

import { useCallback } from 'react';

import { useGetAnalyticsPage } from '@/app/shared/hooks/useGetAnalyticsPage';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { type AnalyticsPage } from '@/packages/utils/analytics';
import { type AnalyticsProducts } from '@/packages/utils/analytics/getAnalyticsProducts';

type Category =
  | 'Listing'
  | 'Phones'
  | 'favorite'
  | 'Auction_block'
  | 'Message_popup'
  | 'complain'
  | 'Compare'
  | 'HideObject'
  | 'label';

type Params = {
  action: string;
  category: Category;
  label?: string | number;
};

type Options = {
  label?: boolean;
  /**
   * @default true
   */
  products?: boolean;
  pageExtra?: Record<string, unknown>;
};

type EventData = {
  action: string;
  category: Category;
  label?: string | number;
  name: 'oldevent';
  products?: AnalyticsProducts;
  page?: AnalyticsPage;
};

type CAForCard = (params: Params, options?: Options) => void;

export function useCAForCard(): CAForCard {
  const { analytics } = useCardOfferContext();

  const page = useGetAnalyticsPage();

  return useCallback<CAForCard>(
    (params, options = {}) => {
      const { products: addProducts = true, label: addGALabel, pageExtra } = options;

      const eventData: EventData = {
        ...params,
        name: 'oldevent',
        page,
      };

      if (pageExtra) {
        eventData.page = {
          ...page,
          extra: {
            ...page.extra,
            ...pageExtra,
          },
        } as AnalyticsPage;
      }

      if (addGALabel) {
        eventData.label = analytics.gaLabel;
      }

      if (addProducts) {
        eventData.products = [analytics.product];
      }

      ca('eventSite', eventData);
    },
    [analytics, page],
  );
}
